/*
  CODE ADDED BY JEREMY TO ADJUST BUY BUTTON AVAILABILITY ACCORDING TO WAREHOUSE STOCK (IRELAND/UK)
*/

function GetVariantId() {
    if ($('.swatch-element input[type="radio"]:checked').length > 0) {
      let variantElmts = $('.swatch-element input[type="radio"]:checked').attr('id').split('-');
      return variantElmts[variantElmts.length - 1];
    }
    else {
      return GetVariantId2();
    }
}


function GetVariantId2() {
    const urlParams = new URLSearchParams(window.location.search);
    let variantId = urlParams.get('variant');
    if (variantId) { return variantId; }

    if (ShopifyAnalytics && ShopifyAnalytics.meta) {
      try {
        const atcForm = document.querySelector("form[action='/cart/add']");
        const variants = ShopifyAnalytics.meta.product.variants;

        if (atcForm) {
          variantId = variants.find((variant) => {
            let variantInput = atcForm.querySelector(`input[type='hidden'][value='${variant.id}']`);
            if (variantInput) { return variantInput.value; }
          });

          if (!variantId) {
            variantId = variants.find((variant) => {
              let variantInput = atcForm.querySelector(`option[data-variant-id='${variant.id}'][selected]`);
              if (variantInput) { return variantInput.value; }
            });
          }

          if (!variantId) {
            variantId = variants.find((variant) => {
              let variantInput = atcForm.querySelector(`option[value='${variant.id}'][selected]`);
              if (variantInput) { return variantInput.value; }
            });
          }
        }

        if (!variantId) { variantId = variants[0]; }

        return variantId.id;
      } catch (e) {
        this.bugsnagNotify(e);
      }
    }

    return variantId;
  }

  $("body").on("click", ".product_swatches", function () {
      CheckStock();
  });

function CheckStock() {
  fetch('https://api.shopify-inventory.jtcinteractive.com/shop/ecoflow-uk.myshopify.com/settings')
  .then(function(response) {
    return response.json();
  })
  .then(function(data) {
    let countryCode = data.settings.userCountryCode;
    //countryCode = 'UK';
    if (countryCode == 'IE') {
      $.ajax({
          url: 'https://api.shopify-inventory.jtcinteractive.com/shop/ecoflow-uk.myshopify.com/variant_locations/' + GetVariantId() + '?lat=0&lon=0',
          dataType: 'json',
          method: 'GET',
          success: function(result) {
            if (result.locations[0].stock <= 0) {
              $('.btn.product-form__cart-submit, .sticky-shop-now-btn').attr('aria-disabled', true).find('span[data-add-to-cart-text]').html('Out of stock');
              
            }
            else {
              $('.btn.product-form__cart-submit, .sticky-shop-now-btn').removeAttr('aria-disabled').find('span[data-add-to-cart-text]').html('Add to cart');
            }
          }
      });
    }
    else if (countryCode == 'UK') {
      $.ajax({
          url: 'https://api.shopify-inventory.jtcinteractive.com/shop/ecoflow-uk.myshopify.com/variant_locations/' + GetVariantId() + '?lat=0&lon=0',
          dataType: 'json',
          method: 'GET',
          success: function(result) {
            if (result.locations[1].stock <= 0) {
              $('.btn.product-form__cart-submit, .sticky-shop-now-btn').attr('aria-disabled', true).find('span[data-add-to-cart-text]').html('Out of stock');
              
            }
            else {
              $('.btn.product-form__cart-submit, .sticky-shop-now-btn').removeAttr('aria-disabled').find('span[data-add-to-cart-text]').html('Add to cart');
            }
          }
      });
    }
  });

}

CheckStock();


